import {
  Mapping,
  MappingLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isMappingLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { getMappingKey } from 'src/containers/ProjectDiagram/utils/mapping/createMapping';
import { getMappingLabelKey } from 'src/containers/ProjectDiagram/utils/mapping/createMappingLabel';
import { getResourceValue } from 'src/containers/ProjectDiagram/utils/resource/createResource';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const changeMappingConnection =
  ({ key, toKey }: { key: string; toKey?: string }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find(
      (existing) => existing.key === key
    );
    if (!mapping || !isMapping(mapping)) {
      return;
    }

    const oldToKey = mapping.to;
    if (oldToKey === toKey) {
      return;
    }

    const mappingLabelKey = mapping.labelKeys[0];
    const mappingLabel = model.nodeDataArray.find(
      (existing) => existing.key === mappingLabelKey
    );

    if (!mappingLabel || !isMappingLabel(mappingLabel)) {
      console.warn(
        new Error(`couldn't find mappingLabelKey ${mappingLabelKey}`)
      );
      return;
    }

    setDataProperty<Mapping>(model)(mapping, 'to', toKey);
    setDataProperty<MappingLabel>(model)(mappingLabel, 'to', toKey);

    const { value } = mapping;
    const fromId = getResourceValue(mapping.from);

    const newMappingKey = getMappingKey({
      value,
      fromId,
      toKey,
    });

    const newMappingLabelKey = getMappingLabelKey({
      value,
      fromId,
      toKey,
    });

    setDataProperty<Mapping>(model)(mapping, 'labelKeys', [newMappingLabelKey]);

    model.setKeyForLinkData(mapping, newMappingKey);
    model.setKeyForNodeData(mappingLabel, newMappingLabelKey);
  };
